import cn from 'classnames';
import * as React from 'react';
import { FC } from 'react';

export interface Heading {
  id?: string;
  title: string | null;
  level: string;
  children: Heading[];
}

const TableOfContentsGroup: FC<{
  headings: Heading[];
  active: string | null;
  inViewport: string | null;
}> = ({ headings, active, inViewport }) => {
  if (!headings || headings.length === 0) return null;

  const stripTrailingPunctuation = (text: string | null) => {
    if (!text) return text;
    return text.replace(/[.:;,]+$/, '').trim();
  };

  return (
    <ul>
      {headings.map((heading, i) => (
        <li
          key={i}
          className={cn({
            active: active === heading.id,
            'in-viewport': inViewport === heading.id
          })}
        >
          <a href={`#${heading.id}`}>{stripTrailingPunctuation(heading.title)}</a>
          {heading.children.length > 0 && (
            <TableOfContentsGroup headings={heading.children} active={active} inViewport={inViewport} />
          )}
        </li>
      ))}
    </ul>
  );
};

export default TableOfContentsGroup;
